import configData from "../config.json";
import Cookies from "universal-cookie";
import CryptoJS from "crypto-js";
export const bindHeader = () => {
  var cookie = new Cookies();
  let headers = new Headers();
  headers.append("Content-Type", "application/json");
  headers.append("Accept", "application/json");
  headers.append("Access-Control-Allow-Origin", configData.API_URL);
  headers.append("Authorization", cookie.get("token"));
  headers.append("deviceid", cookie.get("device"));
  headers.append("Access-Control-Allow-Credentials", "true");
  return headers;
};

export const callAPI = (url, method, body) => {
  var headers = bindHeader();
  return fetch(`${configData.API_URL}${url}`, {
    method: method,
    body: body,
    headers: headers,
  })
    .then(res => res.json())
    .catch(error => {
      console.log(error);
    })
};

const cookies = new Cookies();

export const setCookie = (key, value) => {
  cookies.set(key, encryptString(value));
}
const encryptString = (value) => {
  return CryptoJS.AES.encrypt(value, process.env.REACT_APP_CRYPTO_SECRET).toString()
}
export const getCookie = (key) => {
  const selectedCookie = cookies.get(key);
  if (selectedCookie) {
    let emailBytes = CryptoJS.AES.decrypt(selectedCookie, process.env.REACT_APP_CRYPTO_SECRET);
    let emailData = emailBytes.toString(CryptoJS.enc.Utf8);
    return emailData;
  }
}
export const removeCookie = (key) => {
  cookies.remove(encryptString(key));
}